import React from 'react';
import './Selected.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

const Selected = (props) => {
    const playerProperty = props.selected;
    const totalBudget = playerProperty.reduce((total,player)=> total+player.marketValue, 0);
    return (
        <div className="style">
            <h3>Selected Players Information</h3>
            <p>Total Player Selected: {playerProperty.length} </p>
            <p style={{display:'none', fontWeight:'bold'}} id='show'>Selected Players Are: </p>
            <ul className="list-group list-group-flush">
            {
                playerProperty.map(player => <li className="list-group-item" key={player.id}><FontAwesomeIcon icon={faUserCircle} /> {player.name} <br/> Value: €{player.marketValue} million</li>)
            }
            </ul>
            <p style={{fontWeight:'bold'}} className="show">Total Budget: € {totalBudget} million</p>
        </div>
    );
};

export default Selected;